// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"ContentWrapper--1139h","Border":"Border--3YQOR","Interactive":"Interactive--3EcSW","Title":"Title--2lep6","Padded":"Padded--1L4AB"};